import { Link } from 'react-router';

import 'app/styles/content.css';

const xorArticleLink = [
  'https://medium.com/@glebhusky/',
  'how-i-used-xor-encryption-to-prevent-cheating-and-what-i-learned-1a94c8f5ae37',
].join('');

const Articles = () => (
  <div className="container">
    <div className="content page">
      <Link to="/">
        <div className="close">
          Close
          <span className="close-icon">X</span>
        </div>
      </Link>
      <h1>Articles</h1>
      <h2>
        <a className="link header-link" href={xorArticleLink}>
          How I Used XOR Encryption to Prevent Cheating and What I Learned
        </a>
      </h2>
      <p>
        {[
          'A practical look at using XOR encryption to obfuscate game data,',
          'including design constraints, implementation details and security trade-offs.',
        ].join(' ')}
      </p>
      <a className="link text-link" href={xorArticleLink}>{xorArticleLink}</a>
      <hr />
    </div>
  </div>
);

export default Articles;
